import { useContext, useEffect } from "react";
import { useCreateAccountMutation } from "./register.service";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { CreateAccountContext } from "../../provider/createAccountProvider";
import "../login/style.css";

export default function CreatePasswordPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { setVerifyEmail } = useContext(CreateAccountContext);

  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  // Prefer email from JWT — bare "+" in query strings becomes a space via URLSearchParams
  const emailFromQuery = (query.get("email") || "").trim().toLowerCase();
  let emailFromToken = "";
  try {
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
      emailFromToken = (payload?.email || "").trim().toLowerCase();
    }
  } catch (_) {
    /* ignore */
  }
  const email = emailFromToken || emailFromQuery.replace(/ /g, "+");

  const [
    requestCreateAccount,
    { isSuccess: isCreateAccountSuccess, isLoading: isCreateAccountLoading },
  ] = useCreateAccountMutation();

  // Keep email available for Make Payment → Stripe locked_prefilled_email
  useEffect(() => {
    if (!email) return;
    setVerifyEmail(email);
    try {
      sessionStorage.setItem("sfbb_verify_email", email);
    } catch (_) {
      /* ignore */
    }
  }, [email, setVerifyEmail]);

  const onFinish = (formData) => {
    requestCreateAccount({ ...formData, email, token });
  };

  useEffect(() => {
    if (isCreateAccountSuccess) {
      if (email) {
        setVerifyEmail(email);
        try {
          sessionStorage.setItem("sfbb_verify_email", email);
        } catch (_) {
          /* ignore */
        }
      }
      navigate("/make-payment");
    }
  }, [isCreateAccountSuccess, navigate, email, setVerifyEmail]);

  return (
    <div className="signincontainer signup-page auth-page">
      <div className="saas-card auth-card">
        <div className="auth-brand">
          <div className="auth-logo-wrap">
            <img src="/mark1.jpg" alt="SFBB Pro" />
          </div>
        </div>

        <div className="auth-heading">Create your password</div>
        <p className="auth-copy">
          Set a password to continue your SFBB Pro registration.
        </p>

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className="auth-form"
          requiredMark={false}
          initialValues={{ email: email || "" }}
        >
          <Form.Item name="email" label="Email">
            <Input className="auth-input" size="large" disabled />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            extra={
              <span style={{ color: "rgba(216, 239, 230, 0.75)", fontSize: 12 }}>
                Use the eye icon to show or hide your password
              </span>
            }
            rules={[
              { required: true, message: "Please enter your password!" },
              { min: 6, message: "Password must be at least 6 characters!" },
            ]}
          >
            <Input.Password
              placeholder="Create a password"
              className="auth-input"
              size="large"
              autoComplete="new-password"
            />
          </Form.Item>

          <Button
            htmlType="submit"
            size="large"
            block
            loading={isCreateAccountLoading}
            className="signup-cta-btn"
          >
            Continue
          </Button>
        </Form>

        <div className="auth-footer-note">
          Already registered?{" "}
          <a
            href="/login"
            className="auth-text-link strong"
            onClick={(e) => {
              e.preventDefault();
              navigate("/login");
            }}
          >
            Log in
          </a>
        </div>
      </div>
    </div>
  );
}
